var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 0L0 12H9L8 20L18 8H9L10 0Z","fill":"#CC3333"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }